import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { supabase } from './supabaseClient';

const EmployerProfileContext = createContext(null);

const DEFAULT_EMPLOYER_PROFILE = {
  id: '',
  companyName: '', companyWebsite: '', industry: '', companySize: '',
  contactName: '', contactTitle: '', logoUrl: '',
};

export function EmployerProfileProvider({ children }) {
  const [employerProfile, setEmployerProfile] = useState(DEFAULT_EMPLOYER_PROFILE);
  const [loading, setLoading] = useState(true);

  const fetchEmployerProfile = useCallback(async () => {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.user) { setLoading(false); return; }

    const { data, error } = await supabase
      .from('employer_profiles')
      .select('company_name, company_website, industry, company_size, contact_name, contact_title, logo_url')
      .eq('id', session.user.id)
      .single();

    if (!error && data) {
      setEmployerProfile({
        id: session.user.id,
        companyName:    data.company_name    || '',
        companyWebsite: data.company_website || '',
        industry:       data.industry        || '',
        companySize:    data.company_size    || '',
        contactName:    data.contact_name    || '',
        contactTitle:   data.contact_title   || '',
        logoUrl:        data.logo_url        || '',
      });
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchEmployerProfile();

    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'SIGNED_IN' || event === 'INITIAL_SESSION' || event === 'TOKEN_REFRESHED') {
        if (session?.user) fetchEmployerProfile();
      } else if (event === 'SIGNED_OUT') {
        setEmployerProfile(DEFAULT_EMPLOYER_PROFILE);
      }
    });

    return () => subscription.unsubscribe();
  }, [fetchEmployerProfile]);

  return (
    <EmployerProfileContext.Provider value={{
      employerProfile, setEmployerProfile,
      loading,
      refreshEmployerProfile: fetchEmployerProfile,
    }}>
      {children}
    </EmployerProfileContext.Provider>
  );
}

export function useEmployerProfile() {
  return useContext(EmployerProfileContext);
}
